import { styled, Box, List } from "@mui/material";

export const PopUpSummaryRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  padding: "2rem",
  boxSizing: "border-box",
  backdropFilter: "blur(0.5rem)",
  width: "95dvw",
  height: "fit-content",
  maxHeight: "95dvh",
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  gap: 10,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  margin: "auto",
  background: theme?.palette?.companyColors?.neutral,
  borderRadius: theme?.borderRadius?.small,
  [theme.breakpoints.up("lg")]: {
    padding: "3rem",
    width: "80dvw",
    borderRadius: theme?.borderRadius?.medium,
  },
  [theme.breakpoints.up("xl")]: {
    padding: "5rem",
    width: "60dvw",
  },
}));

export const PopUpSummaryHeader = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  gap: 10,
  marginBottom: 0,
}));

export const PopUpSummaryContent = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "auto",
  zIndex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 10,
}));

export const PopUpSummaryList = styled(List)(({ theme }) => ({
  width: "100%",
  zIndex: 1,
  borderRadius: theme?.borderRadius?.default,
  maxHeight: "35dvh",
  overflowY: "auto",
  background: theme?.palette?.companyColors?.greyLight5,
  borderRight: "2px solid",
  borderRightColor: theme?.palette?.companyColors?.greyLight5,
  "&::-webkit-scrollbar-track": {
    marginTop: 2,
    marginBottom: 2,
  },
}));

export const PopUpSummaryFooter = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: 15,
}));
